<!-- Same composition as the redesigned login; the right side shows who is locked and asks only for the password. -->
<div class="login-experience lock-experience">
  <aside class="login-story">
    <span class="login-wordmark"><img src="assets/img/innporting-logo.svg" alt=""><span class="innporting-wordmark">Innporting</span></span>
    <img class="login-backdrop" src="assets/img/pages/login/login-background.jpg" alt="" aria-hidden="true">
    <div class="story-copy">
      <span class="story-eyebrow">{{'REDESIGN.LOGIN_EYEBROW' | translate}}</span>
      <h1>{{'REDESIGN.LOGIN_TITLE' | translate}}</h1>
      <p>{{'REDESIGN.LOGIN_DESC' | translate}}</p>
    </div>
    <div class="story-bottom"><span><i></i>{{'LOCK_SCREEN.SECURE' | translate}}</span></div>
  </aside>
  <main class="login-main">
    <div class="login-top"><app-language-switch-item></app-language-switch-item></div>
    <div class="login-form-wrap lock-form card-hidden" #lockCard>
      <div class="lock-user">
        <img class="lock-avatar"
             [appUserAvatar]="globals.avatar ? globals.getEnvironment().baseApiUrl + 'files/' + globals.avatar : null"
             [avatarSeed]="globals.userId"
             alt="">
        <div class="lock-identity"><strong>{{globals.name}} {{globals.surname}}</strong><span>{{globals.mail}}</span></div>
      </div>
      <h2>{{'LOCK_SCREEN.TITLE' | translate}}</h2>
      <p class="login-subtitle">{{'LOCK_SCREEN.SUBTITLE' | translate}}</p>
      <form [formGroup]="passwordFormGroup" (ngSubmit)="login()" novalidate>
        <input type="email" class="lock-username" autocomplete="username" [value]="globals.mail" tabindex="-1" aria-hidden="true" readonly>
        <div class="login-field">
          <label for="lock-password">{{'REGISTER_PAGE.PASSWD_INPUT' | translate}}</label>
          <div class="password-control">
            <input id="lock-password" [type]="passwordVisible ? 'text' : 'password'" formControlName="currentPassword" autocomplete="current-password" placeholder="••••••••"
                   [attr.aria-invalid]="passwordFormGroup.get('currentPassword').touched && passwordFormGroup.get('currentPassword').invalid">
            <button type="button" (click)="passwordVisible = !passwordVisible" [attr.aria-label]="(passwordVisible ? 'REDESIGN.HIDE_PASSWORD' : 'REDESIGN.SHOW_PASSWORD') | translate" [attr.aria-pressed]="passwordVisible">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/><path *ngIf="passwordVisible" d="m3 3 18 18"/></svg>
            </button>
          </div>
          <span class="login-error" *ngIf="passwordFormGroup.get('currentPassword').touched && passwordFormGroup.get('currentPassword').invalid">{{(passwordFormGroup.get('currentPassword').errors?.required ? 'REDESIGN.PASSWORD_REQUIRED' : 'LOCK_SCREEN.MIN_LENGTH') | translate}}</span>
        </div>
        <button type="submit" class="login-submit">{{'LOGIN.UNLOCK' | translate}} <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6"/></svg></button>
      </form>
      <p class="lock-switch">{{'LOCK_SCREEN.NOT_YOU' | translate}} <button type="button" (click)="useAnotherAccount()">{{'LOCK_SCREEN.OTHER_ACCOUNT' | translate}}</button></p>
    </div>
    <footer><span>© {{year}} Innporting</span><a href="https://innporting.com/legal-notice-conditions" target="_blank" rel="noopener noreferrer">{{'FOOTER.TERMS_AND_CONDITIONS' | translate}}</a></footer>
  </main>
</div>
